import {Component} from '@angular/core';

@Component({
    selector: 'app-general-ledger',
    templateUrl: './general-ledger.component.html',
    standalone: false
})
export class GeneralLedgerComponent {

}
